import { Controller } from "@hotwired/stimulus"
import { Sortable } from "@shopify/draggable"
import axios from "axios"

export default class extends Controller {
  static targets = ['item']
  static values = { url: String }

  connect() {
    this.sortDelay   = 250
    this.sortTimeout = null

    this.sortable = new Sortable(this.element, {
      draggable: '.js--sortable',
      handle: '.js--handle',
      classes: {
        'source:dragging': 'is--drag-source',
        'draggable:over': 'is--being-dragged-over',
        mirror: 'is--dragged',
      },
      mirror: {
        xAxis: false,
      }
    })

    this.sortable.on('sortable:stop', (e) => {
      window.clearTimeout(this.sortTimeout)
      window.setTimeout(() => { this.sort() }, this.sortDelay)
    })
  }

  sort(e) {
    let ids = []

    this.itemTargets.forEach((item) => {
      ids.push(item.dataset.id)
    })

    axios.post(this.urlValue, {
      ids: ids
    })
    .catch(error => console.warn(error))
  }

  get sortURL() { return this.urlValue }
}
